import { faBell, faCircleExclamation, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';
import { Dayjs } from 'lib';
import { getCssVar } from 'utils';
import { SENSOR_STATUS } from 'config/constants';

export const getSensorStatusProps = (status: string) => {
  switch (true) {
    case new RegExp(`^${SENSOR_STATUS.ACTIVE}`, 'i').test(status):
      return { icon: faCheckCircle, color: getCssVar('--green-500') };
    case new RegExp(`^${SENSOR_STATUS.DELAYED}`, 'i').test(status):
      return { icon: faCircleExclamation, color: getCssVar('--yellow-700') };
    case new RegExp(`^${SENSOR_STATUS.NO_DATA}`, 'i').test(status):
      return { icon: faBell, color: getCssVar('--red-600') };
    default:
      return { icon: faCircleXmark, color: getCssVar('--gray-300') };
  }
};

export const calculateDataAggregationWindow = ({
  dateRange,
  minWindow,
}: {
  dateRange?: { start: Dayjs; end: Dayjs };
  minWindow?: string;
}) => {
  if (!dateRange) return '12h';

  const diffInHours = dateRange.end.diff(dateRange.start, 'hours');

  switch (true) {
    case diffInHours < 5:
      if (minWindow) return minWindow;
      return '20s';
    case diffInHours < 24:
      return '1m';
    case diffInHours < 72:
      return '30m';
    case diffInHours < 768:
      return '6h';
    case diffInHours < 2200:
      return '12h';
    case diffInHours < 4400:
      return '24h';
    default:
      return '48h';
  }
};
